var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"listItem p-2"},[_c('small',{staticClass:"des"},[_vm._v(_vm._s(_vm.des)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.status),expression:"status"}],staticClass:"ml-2 badge badge-pill badge-success"},[_vm._v(_vm._s(_vm.status))])]),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }